import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import Enquire from "./pages/Enquire";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/consulta" element={<Enquire />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
